import FactCheckIcon from '@mui/icons-material/FactCheck';
import { PERMISSIONS } from '../../constants';
import list from './listSkippedBilling';

export default {
  list,
  name: 'skipped-billings',
  permissions: [PERMISSIONS.INVOICES_REPORT],
  icon: FactCheckIcon,
  options: { label: 'Reconciliação' },
};
